import { InvoiceActions, StudentActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { StudentFormData } from 'src/screens/General/screens/Students/components/StudentForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { GetInvoicesAction } from './invoice-actions';

export interface GetStudentsAction {
    type: typeof StudentActions.FETCH_STUDENTS;
    payload: QueryParams;
    all?: any;
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getStudentsCsv(params: QueryParamsAll): GetStudentsAction {
    return {
        type: StudentActions.FETCH_STUDENTS_CSV,
        payload: params,
        all: params.all,
    };
}

export function getStudents(params: QueryParams): GetStudentsAction {
    return {
        type: StudentActions.FETCH_STUDENTS,
        payload: params,
    };
}
export interface GetStudentsSmallAction {
    type: typeof StudentActions.FETCH_STUDENTS_SIMPLY;
    payload: QueryParams;
}

export function getStudentsSmall(params: QueryParams): GetStudentsSmallAction {
    return {
        type: StudentActions.FETCH_STUDENTS_SIMPLY,
        payload: params,
    };
}
export interface GetStudentAction {
    type: typeof StudentActions.FETCH_STUDENT;
    payload: {
        id: string | number;
    };
}

export function getStudent(id: string | number): GetStudentAction {
    return {
        type: StudentActions.FETCH_STUDENT,
        payload: { id },
    };
}

export interface DeleteStudentAction {
    type: typeof StudentActions.DELETE_STUDENT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteStudent(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteStudentAction {
    return {
        type: StudentActions.DELETE_STUDENT,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistStudentAction {
    type: typeof StudentActions.PERSIST_STUDENT;
    payload: {
        data: StudentFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistStudent(data: StudentFormData, files: any, callbacks: SagaPromise<any>): PersistStudentAction {
    return {
        type: StudentActions.PERSIST_STUDENT,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistStudent = (data: StudentFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistStudent(data, files, { resolve, reject }));
    });
};

/*
export const asyncCreateFilesStudent = (id: number | string, requestType: string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesStudent(id, requestType, files, { resolve, reject }));
    });
};
*/

export interface CreateFilesStudentAction {
    type: typeof StudentActions.CREATE_FILES_STUDENT;
    payload: {
        id: number | string;
        requestType: string;
        files: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createFilesStudent(
    id: number | string,
    requestType: string,
    files: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateFilesStudentAction {
    return {
        type: StudentActions.CREATE_FILES_STUDENT,
        payload: {
            id,
            requestType,
            files,
            onSuccess,
            onError,
        },
    };
}

export interface GetFilesAction {
    type: typeof StudentActions.FETCH_FILES_STUDENT;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: StudentActions.FETCH_FILES_STUDENT,
        payload: { id },
    };
}

export interface DeleteFileStudentAction {
    type: typeof StudentActions.DELETE_FILE_STUDENT;
    payload: {
        id: number | string;
        requestType: string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileStudent(
    id: number | string,
    requestType: string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileStudentAction {
    return {
        type: StudentActions.DELETE_FILE_STUDENT,
        payload: { id, requestType, onSuccess, onError },
    };
}

export interface CreateIntakesStudentAction {
    type: typeof StudentActions.CREATE_INTAKE_STUDENT;
    payload: {
        id: number | string;
        requestType: string;
        files: any;
        setLoad: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createIntakesStudent(
    id: number | string,
    requestType: string,
    files: any,
    setLoad: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateIntakesStudentAction {
    return {
        type: StudentActions.CREATE_INTAKE_STUDENT,
        payload: {
            id,
            requestType,
            files,
            setLoad,
            onSuccess,
            onError,
        },
    };
}

export interface GetIntakesAction {
    type: typeof StudentActions.FETCH_INTAKES_STUDENT;
    payload: {
        id: string | number;
    };
}

export function getIntakes(id: string | number): GetIntakesAction {
    return {
        type: StudentActions.FETCH_INTAKES_STUDENT,
        payload: { id },
    };
}

export interface UpdateStudentAction {
    type: typeof StudentActions.UPDATE_STUDENT;
    payload: {
        data: Partial<StudentFormData>;
        callbacks: SagaPromise<any>;
    };
}

export function updateStudent(data: Partial<StudentFormData>, callbacks: SagaPromise<any>): UpdateStudentAction {
    return {
        type: StudentActions.UPDATE_STUDENT,
        payload: {
            data,
            callbacks,
        },
    };
}
export const asyncUpdateStudent = (
    data: Partial<StudentFormData>,
    dispatch: Dispatch,
    success: () => void,
    fail: (reject: any) => void,
) => {
    return new Promise((resolve, reject) => {
        dispatch(
            updateStudent(data, {
                resolve: (resolve) => {
                    success();
                },
                reject: (reject) => {
                    fail(reject);
                },
            }),
        );
    });
};

export type Actions =
    | GetStudentsAction
    | GetStudentAction
    | DeleteStudentAction
    | GetStudentsSmallAction
    | PersistStudentAction;
